import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileWelcome = {
  about: async(props) => {
    const { default: AboutIndex } = await import('@/vue_widgets/geobooster/about/index.vue')
    createVueApp(AboutIndex, { props, sidebar })
  }
}
